import { network } from 'services/network';
import { useQuery } from 'react-query';
import {
    firstEnterUpdateProjectTreeStore,
    ProjectTreeNode,
} from 'components/common/TreeProgramFilter/ProjectTree/projectTree.utils';
import { useProjectTreeStore } from 'store/projectContract.store';

export const getGeneralList = () => {
    const project = useProjectTreeStore.getState().project;
    const contract = useProjectTreeStore.getState().contract;
    const update = useProjectTreeStore.getState().update;

    return network
        .get('api/bo/project/getProgramGeneralHierarchyList')
        .then((response) => {
            firstEnterUpdateProjectTreeStore({ project, contract, update, data: response.data });

            return response.data;
        })
        .catch((error) => {
            throw error;
        });
};

export const useQueryGetGeneralHierarchyList = () => {
    return useQuery<ProjectTreeNode, QueryError>(['getGeneralHierarchyList'], () => getGeneralList());
};
